module.exports = __webpack_public_path__ + "files/df98f8b2499d05c287c640fd9b4b021e.png";